'use client';

import {type Event} from '#/cms/schemas/event.schema';
import {useEffect, useMemo} from 'react';
import useAnalytics, {AnalyticsEventAction, AnalyticsEventCategory} from './useAnalytics';
import {usePlaceStore} from '../store/placeStore';

type Props = {
  event: Event;
};

/**
 * Logs an event to the analytics service when the component mounts.
 */
export const EventViewAnalyticsLogger = (props: Props) => {
  const {event} = props;
  const {placeMap} = usePlaceStore();
  const {registerEvent} = useAnalytics();
  const label = event.title;

  const event_place_ids = useMemo(() => {
    return event.placeIds?.join(',');
  }, [event.placeIds]);

  const event_place_titles = useMemo(() => {
    return event.placeIds?.map(placeId => placeMap.get(placeId)?.title).join(',');
  }, [event.placeIds, placeMap]);

  useEffect(() => {
    if (label && event_place_ids && event_place_titles) {
      registerEvent({
        category: AnalyticsEventCategory.Events,
        action: AnalyticsEventAction.EventView,
        label,
        eventId: event.id,
        event_place_ids,
        event_place_titles,
      });
    }
  }, [event.id, event_place_ids, event_place_titles, label, registerEvent]);

  return null;
};
